import { useEffect } from 'react';
export const useSearchKeyboardControl = ({ activeElement, listRef, }) => {
    useEffect(() => {
        if (listRef) {
            const onAnimationFrame = () => {
                const listItems = Array.from(listRef.children).filter((child) => child.tagName.toLowerCase() === 'li');
                const child = listItems[activeElement];
                if (child) {
                    const ulRect = listRef.getBoundingClientRect();
                    const liRect = child.getBoundingClientRect();
                    if (liRect.bottom > ulRect.bottom) {
                        listRef.scrollTo({
                            top: listRef.scrollHeight,
                            behavior: 'smooth',
                        });
                    }
                    else if (liRect.top < ulRect.top) {
                        listRef.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                        });
                    }
                }
            };
            const animationFrameId = requestAnimationFrame(onAnimationFrame);
            return () => {
                cancelAnimationFrame(animationFrameId);
            };
        }
    }, [activeElement, listRef]);
};
